module.exports = __webpack_public_path__ + "static/media/help.71418f6a.svg";